(function () {
    function createSlider(element, options) {
        if (!element || !window.Swiper) {
            return null;
        }

        if (element.swiper) {
            return element.swiper;
        }

        return new window.Swiper(element, options || {});
    }

    function destroySlider(element) {
        if (element && element.swiper) {
            element.swiper.destroy(true, true);
        }
    }

    window.VitalifySwiper = {
        create: createSlider,
        destroy: destroySlider
    };
})();
